export default __webpack_public_path__ + "static/media/down-arrow.9302c5b4.svg";